// components/layout/Header.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "../ui/ThemeToggle";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-30 border-b border-white/60 bg-[#f8fbff]/85 backdrop-blur-xl dark:border-[#24364f] dark:bg-[#0f1a2b]/90">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3">
          {/* <span className="grid h-10 w-10 place-content-center rounded-xl bg-[#0f3d7a] text-lg text-white shadow-[0_10px_24px_rgba(15,61,122,0.35)]"> */}
            <img
                src="/favicon.png"
                alt="ცენტრალური გათბობის ბოილერის სერვისი"
                className="grid h-10 w-10 place-content-center rounded-xl bg-[#0f3d7a] text-lg text-white shadow-[0_10px_24px_rgba(15,61,122,0.35)]"
              />
          {/* </span> */}
          <div>
            <p className="text-xs uppercase tracking-[0.18em] text-[#5680b8] dark:text-[#7fa2d8]">
              თერმო ფიქსი
            </p>
            <h1 className="text-lg font-bold text-[#0d2340] dark:text-[#e7f0ff]">Thermo Fix</h1>
          </div>
        </Link>

        <nav className="hidden items-center gap-7 text-sm font-semibold text-[#27466f] dark:text-[#c3d8f8] md:flex">
          <Link className="hover:text-[#0f3d7a] dark:hover:text-[#8bb5f2]" to="/services">
            სერვისები
          </Link>
          <Link className="hover:text-[#0f3d7a] dark:hover:text-[#8bb5f2]" to="/gallery">
            გალერეა
          </Link>
          <Link className="hover:text-[#0f3d7a] dark:hover:text-[#8bb5f2]" to="/boiler-error-codes">
            Error კოდები
          </Link>
          <a className="hover:text-[#0f3d7a] dark:hover:text-[#8bb5f2]" href="/#contact">
            კონტაქტი
          </a>
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <ThemeToggle />
          <a
            href="tel:+995557141614"
            className="rounded-full border border-[#d3e2f6] bg-white px-4 py-2 text-xs font-semibold text-[#0f3d7a] shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:border-[#2b3f5c] dark:bg-[#17263a] dark:text-[#c9dcf8] md:inline-flex md:text-sm"
          >
            +995 557 14 16 14
          </a>
        </div>

        <div className="flex items-center gap-2 md:hidden">
          <ThemeToggle />
          <button
            type="button"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-[#d3e2f6] bg-white text-[#0f3d7a] shadow-sm dark:border-[#2b3f5c] dark:bg-[#17263a] dark:text-[#c9dcf8]"
            aria-label="მენიუს გახსნა"
            aria-expanded={isMenuOpen}
          >
            <span className="sr-only">მენიუ</span>
            <span className="flex flex-col gap-1.5">
              <span className="block h-0.5 w-5 rounded bg-current" />
              <span className="block h-0.5 w-5 rounded bg-current" />
              <span className="block h-0.5 w-5 rounded bg-current" />
            </span>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="border-t border-[#dfe9f8] bg-white px-6 py-4 dark:border-[#2a3c57] dark:bg-[#111f33] md:hidden">
          <nav className="flex flex-col gap-3 text-sm font-semibold text-[#27466f] dark:text-[#c3d8f8]">
            <Link to="/services" onClick={() => setIsMenuOpen(false)}>
              სერვისები
            </Link>
            <Link to="/gallery" onClick={() => setIsMenuOpen(false)}>
              გალერეა
            </Link>
            <Link to="/boiler-error-codes" onClick={() => setIsMenuOpen(false)}>
              Error კოდები
            </Link>
            <a href="/#contact" onClick={() => setIsMenuOpen(false)}>
              კონტაქტი
            </a>
            <a
              href="tel:+995557141614"
              className="mt-1 inline-flex w-fit rounded-full border border-[#d3e2f6] bg-white px-4 py-2 text-xs font-semibold text-[#0f3d7a] dark:border-[#2b3f5c] dark:bg-[#17263a] dark:text-[#c9dcf8]"
            >
              +995 557 14 16 14
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
